import * as types from './types';
import produce from 'immer';

export const versionsState = {
    solutions: [],
    lists: []
};

const produceVersionsList = produce( ( draft, action ) => {
    const index = draft.lists.findIndex( version => version.solutionId === action.id );
    draft.lists[ index ].list = action.list;
} );
const produceSolutionsLists = produce( ( draft, action ) => {
    draft.solutions = action.solutions;
    draft.lists = [];
    action.solutions.map( solution => {
        draft.lists.push( { name: solution.name, solutionId: solution.id, list: [] } );
    } );
} );

export const versionsReducer = ( state = versionsState, action ) => {
    switch ( action.type ) {
        case types.VERSIONS__SET_VERSIONS_LIST:
            return produceVersionsList( state, action );
        case types.VERSIONS__SET_SOLUTIONS:
            return produceSolutionsLists( state, action );
        case types.VERSIONS__CLEAR_VERSIONS:
            return versionsState;
        default:
            return state;
    }
};
